import { Component, Input, NgZone, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
@Component({
  selector: 'app-esim-activation-code-for-devices',
  templateUrl: './esim-activation-code-for-devices.component.html',
  styleUrls: ['./esim-activation-code-for-devices.component.scss']
})
export class EsimActivationCodeForDevicesComponent implements OnInit {
  @Input() devictypes: any;
  @Input() checkouteSimData: any;
  activationCode: any;
  ENV: any
  constructor(private modalController: ModalController, private UTS: UtilitiesService, private ngZone: NgZone ,private GAS:GoogleAnalyticsService) { }

  ngOnInit(): void {
    if (this.checkouteSimData) {
      this.activationCode = this.checkouteSimData ? "LPA:" + "1$" + this.checkouteSimData?.smdpAddress + "$" + this.checkouteSimData?.matchingId : ""
    }
    this.ENV = localStorage.getItem('ENV');
  }
  clicktoCopy(data) {
    navigator.clipboard.writeText(data);
    var active = "Copy SM-DP-Address" + " "+ this.devictypes;
    this.GAS.postpaidEsimInstall('postpaid_esim_install',active,this.activationCode);
  }
  dismiss() {
    this.modalController.dismiss({ dismissed: true });
  }
  ContinueEsimNativeFlow() {
    const OS = this.UTS.getMobileOperatingSystem();
    if (this.ENV == 'mobile' && OS == 'Android') {
      (window as any).deals.initEsimFlowActivation();
    } else if (this.ENV == 'mobile' && OS == 'iOS') {
      (window as any).webkit.messageHandlers.hybridInterface.postMessage('initEsimFlowActivation');
    }
    this.modalController.dismiss({ dismissed: true });
  }
  ContinueEsimInstallOnDevice() {
    this.GAS.postpaidEsimInstall('postpaid_esim_install_confirm','eSimactivation Continue',this.activationCode);
    const OS = this.UTS.getMobileOperatingSystem();
    const payload = {
      address: this.checkouteSimData ? this.checkouteSimData?.smdpAddress : "",
      matchingID: this.checkouteSimData ? this.checkouteSimData?.matchingId : "",
      confirmationCode: "",
      ICCID: "",
      EID: ""
    };
    if (this.ENV == 'mobile' && OS == 'Android') {
      (window as any).deals.initDeviceInstatlion(JSON.stringify(payload));
    } else if (this.ENV == 'mobile' && OS == 'iOS') {
      const messgeToPost = {
        method: 'initDeviceInstatlion',
        payload: JSON.stringify(payload)
      };
      (window as any).webkit.messageHandlers.hybridInterface.postMessage(
        JSON.stringify(messgeToPost)
      );
    }
    this.modalController.dismiss({ dismissed: true });
  }
  CancleEsimInstallOnDevice(){
    this.GAS.postpaidEsimInstall('postpaid_esim_install_confirm','eSimactivation Cancel',this.activationCode);
    this.modalController.dismiss({ dismissed: true });
  }
 
  CLose(){
    this.modalController.dismiss()
  }
}
